import React from 'react';
import LogoutButton from '../LogoutButton/LogoutButton';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen relative">
      <LogoutButton />
      {children}
    </div>
  );
};

export default Layout;